import getData from '@services/api/common/getData';
import appConfig from '@configs/appConfig';
import { triggers } from '@constants/appRoutes';

export const getTriggers = messageId =>
  getData(`${appConfig.baseUrl}${triggers}get-by-message/${messageId}`);
